import { render } from "./view-kv-customer-new.vue?vue&type=template&id=6a961013"
import script from "./view-kv-customer-new.vue?vue&type=script&setup=true&lang=js"
export * from "./view-kv-customer-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/view-kv-customer/view-kv-customer-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a961013"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a961013', __exports__)) {
    api.reload('6a961013', __exports__)
  }
  
  module.hot.accept("./view-kv-customer-new.vue?vue&type=template&id=6a961013", () => {
    api.rerender('6a961013', render)
  })

}


export default __exports__